var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    transform: "rotate(90 31.5 0.5)",
    fill: "#CFD2FA",
    stroke: "#0F20E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2659 10.7354C16.5314 10.7355 16.7858 10.8413 16.9733 11.0293L20.4433 14.5092C20.8333 14.9003 20.8323 15.5335 20.4413 15.9235C20.0502 16.3134 19.417 16.3125 19.027 15.9214L16.2641 13.1506L13.4923 15.9224C13.1017 16.313 12.4686 16.313 12.078 15.9224C11.6875 15.5319 11.6875 14.8987 12.0781 14.5082L15.5581 11.0282C15.7458 10.8405 16.0004 10.7352 16.2659 10.7354Z",
    fill: "#0F20E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2659 16.7354C16.5314 16.7355 16.7858 16.8413 16.9733 17.0293L20.4433 20.5092C20.8333 20.9003 20.8323 21.5335 20.4413 21.9235C20.0502 22.3134 19.417 22.3125 19.027 21.9214L16.2641 19.1506L13.4923 21.9224C13.1017 22.313 12.4686 22.313 12.078 21.9224C11.6875 21.5319 11.6875 20.8987 12.0781 20.5082L15.5581 17.0282C15.7458 16.8405 16.0004 16.7352 16.2659 16.7354Z",
    fill: "#0F20E8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.2116c50c750609265e39785fc9eb05ba.svg";
export { ForwardRef as ReactComponent };